module.exports = __webpack_public_path__ + "static/media/11.238b9251.jpeg";